/**
 * Model walidacyjny (Pre-flight check) wykorzystywany przed usunięciem
 * typu wizyty ze słownika.
 * Dostarcza informacje o istniejących powiązaniach w bazie danych,
 * co pozwala interfejsowi na zablokowanie akcji kasowania lub wyświetlenie
 * odpowiedniego ostrzeżenia ("Czy na pewno chcesz usunąć?").
 */
export class ReservationsCheck {

  /** Główna flaga logiczna informująca, czy istnieją jakiekolwiek powiązane rekordy.
   */
  public existAny: boolean;

  /** Dokładna liczba aktywnych rezerwacji przypisanych do typu wizyty.
   * Pozwala na zbudowanie precyzyjnego komunikatu dla użytkownika (np.
   * "Aktualnie dla tego typu wizyty zaplanowanych jest ... rezerwacji").
   */
  public reservationCounter: number;

  /** Liczba zaplanowanych przypomnień o kolejnej wizycie powiązanych z tym typem.
   * Pozwala na zbudowanie precyzyjnego komunikatu dla użytkownika (np.
   * "Aktualnie dla tego typu wizyty zaplanowanych jest ... zaproszeń na wizytę").
   */
  public nextVisitReminderCounter: number;

}
